import { useState } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";
import { THANKSGIVING_PICKUP, thanksgivingOpen } from "@/data/site";

const KEY = "lss-holiday-banner-dismissed";

export const HolidayBanner = () => {
  const [hidden, setHidden] = useState(() => localStorage.getItem(KEY) === "1");
  if (hidden || !thanksgivingOpen()) return null;
  const close = () => {
    localStorage.setItem(KEY, "1");
    setHidden(true);
  };
  return (
    <div data-testid="holiday-banner" className="bg-espresso text-cream">
      <div className="mx-auto max-w-[1440px] pl-5 pr-11 md:px-10 py-2.5 flex items-center justify-center gap-3 text-[11px] sm:text-xs tracking-[0.14em] uppercase relative">
        <svg viewBox="0 0 20 20" className="w-2.5 h-2.5 text-gold shrink-0 hidden sm:block" aria-hidden="true"><path d="M10 0l2.4 7.6L20 10l-7.6 2.4L10 20l-2.4-7.6L0 10l7.6-2.4z" fill="currentColor" /></svg>
        <span className="text-center">
          <span className="sm:hidden">Order by Nov 18 · Pickup Nov 24</span>
          <span className="hidden sm:inline">Thanksgiving preorders · Order by {THANKSGIVING_PICKUP.orderByLabel} · Pickup {THANKSGIVING_PICKUP.label}</span>
        </span>
        <Link to="/custom-orders?occasion=Thanksgiving%20Preorder" data-testid="holiday-banner-cta" className="link-u text-gold whitespace-nowrap pb-0.5">Preorder</Link>
        <button data-testid="holiday-banner-close" onClick={close} aria-label="Dismiss" className="absolute right-3 md:right-8 p-1 text-[#CDBBA8] hover:text-cream">
          <X className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  );
};
